import { Link, Text, Stack, Flex, useBoolean } from "@chakra-ui/react";

interface ContactInfoProps {
	isMobile?: boolean;
	label: string;
	value: string;
	link: string;
}

export const ContactInfo = (props: ContactInfoProps) => {
	const { label, value, link, isMobile = false } = props;

	const [isFocused, setIsFocused] = useBoolean();

	return (
		<Link
			isExternal
			href={link}
			w="fit-content"
			onMouseEnter={setIsFocused.on}
			onMouseLeave={setIsFocused.off}
			_hover={{ textDecoration: "none" }}
		>
			{isMobile ? (
				<i>
					<Flex gap="1.5">
						<Text opacity="69%">{label}</Text>

						<Text color={isFocused ? "brand.contrast" : "brand.dark"}>
							{value}
						</Text>
					</Flex>
				</i>
			) : (
				<Stack gap="1">
					<Text opacity="69%" fontSize="sm">
						<i>{label}</i>
					</Text>

					<Text color={isFocused ? "brand.contrast" : "brand.dark"}>
						{value}
					</Text>
				</Stack>
			)}
		</Link>
	);
};
